export const AIRPORT_TRANSFER_GET_ROUTES_BEGIN = 'AIRPORT_TRANSFER_GET_ROUTES_BEGIN';
export const AIRPORT_TRANSFER_GET_ROUTES_SUCCESS = 'AIRPORT_TRANSFER_GET_ROUTES_SUCCESS';
export const AIRPORT_TRANSFER_GET_ROUTES_FAILURE = 'AIRPORT_TRANSFER_GET_ROUTES_FAILURE';
export const AIRPORT_TRANSFER_GET_ROUTES_DISMISS_ERROR = 'AIRPORT_TRANSFER_GET_ROUTES_DISMISS_ERROR';
export const AIRPORT_TRANSFER_SET_ROUTES = 'AIRPORT_TRANSFER_SET_ROUTES';
export const AIRPORT_TRANSFER_AIRPORT_TRANSFER_BOOK_BEGIN = 'AIRPORT_TRANSFER_AIRPORT_TRANSFER_BOOK_BEGIN';
export const AIRPORT_TRANSFER_AIRPORT_TRANSFER_BOOK_SUCCESS = 'AIRPORT_TRANSFER_AIRPORT_TRANSFER_BOOK_SUCCESS';
export const AIRPORT_TRANSFER_AIRPORT_TRANSFER_BOOK_FAILURE = 'AIRPORT_TRANSFER_AIRPORT_TRANSFER_BOOK_FAILURE';
export const AIRPORT_TRANSFER_AIRPORT_TRANSFER_BOOK_DISMISS_ERROR = 'AIRPORT_TRANSFER_AIRPORT_TRANSFER_BOOK_DISMISS_ERROR';
export const AIRPORT_TRANSFER_AIRPORT_TRANSFER_SELECT_SERVICE_TO_BOOK = 'AIRPORT_TRANSFER_AIRPORT_TRANSFER_SELECT_SERVICE_TO_BOOK';
export const AIRPORT_TRANSFER_AIRPORT_TRANSFER_RETURN_SERVICE_TO_BOOK = 'AIRPORT_TRANSFER_AIRPORT_TRANSFER_RETURN_SERVICE_TO_BOOK';
export const AIRPORT_TRANSFER_SHOW_HIDE_TOP_SEARCH_BAR = 'AIRPORT_TRANSFER_SHOW_HIDE_TOP_SEARCH_BAR';



// WEBPACK FOOTER //
// ./src/features/airport-transfer/redux/constants.js